import { createModel, RematchDispatch } from '@rematch/core';
import * as itemInfoService from '../../services/itemInfo.service';
import { PaginationType } from '../../types/CommonTypes';
import { ItemInfoData } from '../../types/ItemInfoData';
import { RootModel } from '../models';

import baseEntity from './base.entity';

export const storeName = 'itemInfoEntity';

export const itemInfoEntity: any = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: RematchDispatch<typeof itemInfoEntity>) => ({
    async loadById(id, state): Promise<ItemInfoData> {
      try {
        const item = state[storeName].ids[id];
        if (item && !item.isSimplified) {
          return item;
        }

        const { data } = await itemInfoService.getItemInfo(id);
        this.saves([data]);
        return data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async load(params): Promise<{ content?: ItemInfoData[] } & PaginationType> {
      try {
        const res = await itemInfoService.getItemInfos(params);
        const { content } = res.data;
        if (content && content.length) {
          this.saveSimplified(content);
        }
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async delete(payload) {
      try {
        await itemInfoService.deleteItemInfo(payload);
        this.remove(payload);
      } catch (e) {
        throw new Error(e);
      }
    },
    async create(payload) {
      try {
        const { data: item } = await itemInfoService.createItemInfo(payload);
        this.saves([item]);
        return item;
      } catch (e) {
        throw new Error(e);
      }
    },
    async update(payload) {
      try {
        const { data: item } = await itemInfoService.updateItemInfo(payload);
        this.saves([item]);
        return item;
      } catch (e) {
        throw new Error(e);
      }
    },
  }),
});

export default itemInfoEntity;
